export const TOOLTIP_CLASS = "widget-frame-title-information-tooltip";
